/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { ListingCardAnchor } from './ListingCardAnchor';
import {
  ListingCardProperty,
  ListingCardPropertyProps,
} from './ListingCardProperty';
import { ListingCardSkeleton } from './ListingCardSkeleton';
import {
  ListingCardUnitType,
  ListingCardUnitTypeProps,
} from './ListingCardUnitType';
import { ListingCardBaseProps } from './types';

const ListingCardDefaultHighlights = ({
  listing,
}: Pick<ListingCardBaseProps, 'listing'>) => {
  if (listing.identifiers.recordType === 'property') {
    return <ListingCardProperty.Highlights listing={listing} />;
  }

  return <ListingCardUnitType.Highlights listing={listing} />;
};

type ListingCardUnifiedProps = ListingCardBaseProps &
  Pick<ListingCardPropertyProps | ListingCardUnitTypeProps, 'className'>;

const ListingCardUnified = ({ listing, ...rest }: ListingCardUnifiedProps) => {
  if (listing.identifiers.recordType === 'property') {
    return <ListingCardProperty listing={listing} {...rest} />;
  }

  return <ListingCardUnitType listing={listing} {...rest} />;
};

ListingCardUnified.Highlights = ListingCardDefaultHighlights;

export const ListingCard = {
  Anchor: ListingCardAnchor,
  Skeleton: ListingCardSkeleton,
  Unified: ListingCardUnified,
  Property: ListingCardProperty,
  UnitType: ListingCardUnitType,
};
